const React = require('react');


module.exports = (props) => (
  <svg
    width="28" height="19"
    viewBox="0 0 28 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2" y="8" width="26" height="2"/>
    <path
      d="M1.41421 7.77817L10.6066 16.9706L9.19238 18.3848L-4.78379e-06 9.19239L1.41421 7.77817Z"/>
    <path
      d="M-4.78379e-06 9.19239L9.19238 6.18172e-08L10.6066 1.41421L1.41421 10.6066L-4.78379e-06 9.19239Z"/>
  </svg>
);
